var UiModule = /** @class */ (function () {
    function UiModule() {
    }
    return UiModule;
}());
export { UiModule };
